"use client";

import React, { useState, useCallback } from "react";
import Link from "next/link";
import Image from "next/image";
import { useSelector } from "react-redux";
import { useRouter, useSearchParams } from "next/navigation";
import { Drawer } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import "./FashionMobileHeader.scss";
import { AiOutlineSearch } from "react-icons/ai";
import { BsHandbag } from "react-icons/bs";
import { FaWhatsapp } from "react-icons/fa";
import { IoCloseSharp } from "react-icons/io5";
import { AiOutlineUser } from "react-icons/ai";
import SearchForMobile from "../../Search/MobileSearch/MobileSearchh";
import FashionCartDrawer from "@/components/CartPage/Modules/FashionCartDrawer/FashionCartDrawer";
import AccountStatus from "@/functions/Cookies/Cookies";
import FashionHeaderToggleButtons from "./FashionHeaderToggleButtons";
import FashionHeaderCountryDropdown from "../Navigation/AlfaHeaderCountryDropdown/AlfaHeaderCountryDropdown";
import logo from "@/assets/alfafashionimages/alfafashionlogo.svg";
import iconMenu from "@/assets/alfafashionimages/icon-menu.png";
import Cookies from "js-cookie";
import { normalizeFashionNavLink } from "./fashionNavLinkUtils";

const FashionMobileHeader = ({ navigationData = [], userAgent }) => {
  const { isDesktop, isMobile, isTablet } = userAgent;
  const searchParams = useSearchParams();
  const isV1 = searchParams?.get('q') === 'v1';

  const { loggedIn } = AccountStatus();

  const [showSearch, setShowSearch] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [expandedSubCategory, setExpandedSubCategory] = useState(null);
  const [showAnnouncement, setShowAnnouncement] = useState(true);

  const cartId = Cookies.get("cartId");
  const cartCountTotalValue = useSelector((state) =>
    cartId ? state.cartSlice.cartCountTotal : 0,
  );

  const router = useRouter();

  const navigateToFashionLink = (link) => {
    const target = normalizeFashionNavLink(link);
    if (!target) return;
    if (target.startsWith("http://") || target.startsWith("https://")) {
      window.location.assign(target);
      return;
    }
    router.push(target.startsWith("/") ? target : `/${target}`);
  };

  const handleSearchToggle = useCallback(() => {
    setShowSearch((prev) => !prev);
  }, []);

  const handleMenuClose = () => {
    setShowMenu(false);
    setExpandedCategory(null);
    setExpandedSubCategory(null);
  };

  const toggleCategory = (index) => {
    setExpandedCategory(expandedCategory === index ? null : index);
    setExpandedSubCategory(null);
  };

  const renderMenuContent = () => (
    <div className="fashion-mobile-menu">
      <div className="fashion-mobile-menu__close-bar">
        <button
          type="button"
          className="fashion-mobile-menu__close"
          onClick={handleMenuClose}
          aria-label="Close menu"
        >
          <CloseOutlined />
        </button>
      </div>

      {/* Header with Logo and Close */}
      {/* <div className="fashion-mobile-menu__header">
        <Link href="/fashion" onClick={handleMenuClose}>
          <Image
            src={logo}
            height={80}
            width={80}
            alt="Alfa Fashion Logo"
            priority
          />
        </Link>
      </div> */}

    
      {/* Categories */}
      <div className="fashion-mobile-menu__categories">
        {navigationData && navigationData.length > 0 ? (
          navigationData.map((item, index) => {
            const hasChildren = item.children && item.children.length > 0;
            return (
              <div key={index} className="fashion-mobile-menu__category">
                <div
                  className="fashion-mobile-menu__category-header"
                  onClick={() => {
                    if (hasChildren) toggleCategory(index);
                    else {
                      navigateToFashionLink(item.link);
                      handleMenuClose();
                    }
                  }}
                >
                  <span className="fashion-mobile-menu__category-name">
                    {item.label}
                  </span>
                  {hasChildren && (
                    <span className="fashion-mobile-menu__category-icon">
                      {expandedCategory === index ? "−" : "+"}
                    </span>
                  )}
                </div>

                {expandedCategory === index && hasChildren && (
                  <div className="fashion-mobile-menu__subcategories">
                    {item.children.map((child, childIndex) => {
                      const hasGrandChildren = child.children && child.children.length > 0;
                      const subKey = `${index}-${childIndex}`;
                      return (
                        <div key={childIndex} className="fashion-mobile-menu__subcategory-group">
                          <div
                            className="fashion-mobile-menu__subcategory-header"
                            onClick={() => {
                              if (hasGrandChildren) {
                                setExpandedSubCategory(expandedSubCategory === subKey ? null : subKey);
                              } else {
                                navigateToFashionLink(child.link);
                                handleMenuClose();
                              }
                            }}
                          >
                            <span className="fashion-mobile-menu__subcategory">{child.label}</span>
                            {hasGrandChildren && (
                              <span className="fashion-mobile-menu__category-icon" style={{ fontSize: "12px" }}>
                                {expandedSubCategory === subKey ? "−" : "+"}
                              </span>
                            )}
                          </div>

                          {expandedSubCategory === subKey && hasGrandChildren && (
                            <div className="fashion-mobile-menu__grandchildren">
                              {child.children.map((grandChild, grandIndex) => (
                                <Link
                                  key={grandIndex}
                                  href={normalizeFashionNavLink(grandChild.link) || "#"}
                                  className="fashion-mobile-menu__grandchild"
                                  onClick={handleMenuClose}
                                >
                                  {grandChild.label}
                                </Link>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div className="fashion-mobile-menu__empty">
            <p>No categories available</p>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="fashion-mobile-menu__footer">
        {/* <div className="fashion-mobile-menu__footer-links">
          <Link
            href="/wishlist"
            className="fashion-mobile-menu__footer-link"
            onClick={handleMenuClose}
          >
            My Wishlist
          </Link>
          <Link
            href={loggedIn ? "/account" : "/login"}
            className="fashion-mobile-menu__footer-link"
            onClick={handleMenuClose}
          >
            My Account
          </Link>
        </div> */}

        {/* <div className="fashion-mobile-menu__country">
          <FashionHeaderCountryDropdown
            selectedCountry="Pakistan"
            onCountryChange={(country) => {
}}
          />
        </div> */}

        <div className="fashion-mobile-menu__brand-buttons">
          <FashionHeaderToggleButtons />
        </div>
      </div>
    </div>
  );

  return (
    <>
      {/* Announcement Bar */}
      {showAnnouncement && !isV1 && (
        <div className="fashion-mobile-announcement">
          <Link href="/fashion" className="fashion-mobile-announcement__text">
            Free Delivery on All Prepaid Orders!
          </Link>
          <button
            className="fashion-mobile-announcement__close"
            onClick={() => setShowAnnouncement(false)}
          >
            <IoCloseSharp />
          </button>
        </div>
      )}

      {/* Main Header */}
      <div
        className={`fashion-mobile-header ${showAnnouncement && !isV1 ? "fashion-mobile-header--with-announcement" : ""}`}
      >
        <div className="fashion-mobile-header__left">
          {!isV1 && (
            <div
              className="fashion-mobile-header__hamburger"
              onClick={() => setShowMenu(true)}
            >
              <Image src={iconMenu} alt="Menu" width={20} height={20} />
            </div>
          )}
          <div className="fashion-mobile-header__currency">
            <FashionHeaderCountryDropdown   selectedCountry="Pakistan"
            onCountryChange={(country) => {
}} />
          </div>
        </div>

        <div className="fashion-mobile-header__center">
          <Link href="/fashion">
            <Image
              src={logo}
              height={80}
              width={80}
              alt="Alfa Fashion Logo"
              priority
            />
          </Link>
        </div>

        <div className="fashion-mobile-header__right">
         

          <div
            className="fashion-mobile-header__icon"
            onClick={handleSearchToggle}
            role="button"
            tabIndex={0}
            aria-label="Toggle search"
          >
            <AiOutlineSearch style={{ fontSize: "20px" }} />
          </div>

          <Link
            href={loggedIn ? "/account" : "/login"}
            className="fashion-mobile-header__icon"
            aria-label="Account"
          >
            <AiOutlineUser style={{ fontSize: "20px" }} />
          </Link>

          <div
            className="fashion-mobile-header__icon"
            style={{ position: "relative" }}
          >
            {cartCountTotalValue > 0 && (
              <div className="fashion-mobile-header__cart-count">
                {cartCountTotalValue}
              </div>
            )}
            <FashionCartDrawer
              customIcon={<BsHandbag style={{ fontSize: "18px" }} />}
            />
          </div>
        </div>
      </div>

      {/* Search Bar - Expandable */}
      {showSearch && (
        <div className="fashion-mobile-header__search-container">
          <div className="fashion-mobile-header__search-inner">
            <SearchForMobile
              userAgent={{ isMobile, isTablet, isDesktop }}
              setShowMegaSearch={setShowSearch}
              isFashion={true}
            />
          </div>
        </div>
      )}

      {/* Side Menu Drawer */}
      <Drawer
        placement="left"
        onClose={handleMenuClose}
        open={showMenu}
        width="80%"
        rootClassName="fashion-mobile-menu-drawer"
        closeIcon={null}
        styles={{
          mask: { backgroundColor: "rgba(0, 0, 0, 0.4)" },
        }}
      >
        {renderMenuContent()}
      </Drawer>
    </>
  );
};

export default FashionMobileHeader;
